export const resourceName = 'Permissão de usuário';
export const resourcePluralTitle = 'Permissões de usuários';
// @todo: review
export const resourceKey = 'permissao/filtro';
export const resourceKeyItem = 'permissao';

export const idKey = 'id';

export const headers = [
  { key: 'rotina.nome', title: 'Rotina' },
  { key: 'funcionalidade', title: 'Funcionalidade' },
  { key: 'usuarioliberacao.nome', title: 'Liberado Por' },
  { key: 'dataliberacao', title: 'Data da liberação' },
  { key: 'ativo', title: 'Ativo', filter: (v: boolean) => v ? 'True' : 'False' },
];
